<template>
  <div v-show="isVisible" :class="['wrapper', 'wrap-left', 'h-100', { 'open-modal-left': isOpen }]">
    <div class="modalBody bg-white w-100 h-100">
      <div class="modalHeader">
        <div class="title-section">{{ title }}</div>
        <div class="close-modal-button" @click="startClose"></div>
      </div>
      <div class="modalContent" v-if="isClient">
        <client-only>
        <div v-if="loading" class="lb-cancel d-block"></div>
        <div v-else-if="error">{{ error }}</div>
        <div v-else v-html="content"></div>
        </client-only>
      </div>
    </div>
    <div class="overlay" @click="startClose"></div>
  </div>
</template>

<script>
export default {
  name: "LazyContentModal",
  props: {
    categoryId: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      default: ""
    },
    visible: {
      type: Boolean,
      required: true
    }
  },
  mounted() {
    this.isClient = true;
  },
  data() {
    return {
      content: "",
      loading: false,
      error: "",
      hasLoaded: false,
      isOpen: false,
      isVisible: false,
      isClient: false
    };
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.isVisible = true;

        // mit 2 Frames Delay → Animation funktioniert sauber
        this.$nextTick(() => {
          requestAnimationFrame(() => {
            this.isOpen = true;
          });
        });

        if (!this.hasLoaded) {
          this.loadContent();
        }
      } else {
        this.startClose();
      }
    }
  },
  methods: {
    startClose() {
      this.isOpen = false;
      setTimeout(() => {
        this.isVisible = false;
        this.$emit("close");
      }, 300);
    },
    loadContent() {
      this.loading = true;
      this.error = "";

      fetch(`/plugin/ETCeresCoconut/load-content/${this.categoryId}`)
          .then(res => {
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            return res.text();
          })
          .then(html => {
            if (!html || html.trim() === "") {
              throw new Error("Leerer Inhalt");
            }
            this.content = html;
            this.hasLoaded = true;
          })
          .catch(err => {
            this.error = "Fehler beim Laden der Inhalte.";
            console.error("[LazyContentModal] Ladefehler:", err);
          })
          .finally(() => {
            this.loading = false;
          });
    }

  }
};
</script>
